export default {
      id: "trash-usage",
      viewBox: "0 0 12 14",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#trash",
      toString: function () {
        return this.url;
      }
    }